import Boom from 'boom'
import makeApi from '../client/api'

export const sendCodeSMS = async (phone, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const { ok, data } = await api.post('/sms/pin', { phone: phone })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}

export const verifyCodeSMS = async (pin, user_id, pinId, token) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const { ok, data } = await api.post(`/sms/pin/${pinId}`, { pin, user_id })

  if (!ok) {
    throw Boom.forbidden()
  }

  return data
}
